<agr-page-detail [pageTitle]="pageTitle()" (backAction)="back()">
  <app-employee-navigation></app-employee-navigation>

  <div [@routeAnimations]="routeAnimationState()">
    <router-outlet></router-outlet>
  </div>
</agr-page-detail>
